// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tMVDdeH4SXVlrT {
  background: rgba(0, 0, 0, 0.5);
}
.PGWcxlcX3OqT8A {
  position: relative;
  min-width: 375px;
  max-width: 600px;
  border-radius: 10px;
  background-color: var(--ds-surface, #ffffff);
}
.iyzNw580ZkMyd5 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px 24px 0 24px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  background-color: #1868db;
}
.iyzNw580ZkMyd5 h1 {
  margin-top: 8px;
  color: #ffffff;
  font-size: 20px;
  line-height: 24px;
}
.HMSj25f9cXeNJN {
  display: block;
  width: 100%;
}
.yCxOEZGh2VqxI1 {
  margin-left: 40px;
}
.Sw0ZsWJgN4Ltg3 {
  padding: 32px 24px 40px 24px;
  text-align: center;
}
.Sw0ZsWJgN4Ltg3 p {
  padding: 0 48px;
}
.ID_SeQDUFPW5Jy {
  display: flex;
  justify-content: center;
  margin-top: 40px;
  column-gap: 8px;
}
.VcVqDTp5drYnfl > span {
  margin-left: 4px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `tMVDdeH4SXVlrT`,
	"ppOptInModal": `PGWcxlcX3OqT8A`,
	"headingContainer": `iyzNw580ZkMyd5`,
	"headingImage": `HMSj25f9cXeNJN`,
	"trelloIconEyelash": `yCxOEZGh2VqxI1`,
	"contentContainer": `Sw0ZsWJgN4Ltg3`,
	"ctasContainer": `ID_SeQDUFPW5Jy`,
	"enabledBeta": `VcVqDTp5drYnfl`
};
export default ___CSS_LOADER_EXPORT___;
